export default __webpack_public_path__ + "static/KonradTrzyna-dce0d0bb464bc9d316a2bf50b11b020f.png";